export const translations = {
  it: {
    nav: {
      title: "Menu",
      home: "Home",
      about: "Chi Siamo",
      services: "Servizi",
      podcast: "Podcast",
      blog: "Blog",
      contact: "Contatti",
    },
    hero: {
      title: "Soluzioni legali e fiscali su misura a Panama",
      subtitle: "Affidati a un esperto per residenza, società offshore e investimenti",
      cta: "Richiedi una consulenza personalizzata",
    },
    about: {
      title: "Chi Siamo",
      description: "Siamo un team di avvocati e consulenti finanziari, specializzati in diversi ambiti del diritto e lavoriamo con determinazione per garantire la soddisfazione dei nostri clienti.",
      payment: "La nostra politica prevede il pagamento solo al completamento del procedimento, garantendo così la massima trasparenza e sicurezza per i nostri clienti.",
      cta: "Richiedi una consulenza gratuita",
      experience: "Anni di Esperienza",
      clients: "Clienti Soddisfatti",
    },
    services: {
      title: "I Nostri Servizi",
      subtitle: "Soluzioni legali e fiscali complete per la tua vita e i tuoi affari a Panama",
      residence: {
        title: "Residenza a Panama",
        description: "Ottieni la residenza a Panama con il supporto di un esperto. Residenza permanente immediata tramite il Trattato Panama-Italia. Passaporto panamense in 5 anni. Ideale per nomadi digitali e fiscali.",
        cta: "Contattaci per saperne di più",
      },
      offshore: {
        title: "Società Offshore",
        description: "Panama è leader nei servizi offshore, logistica marittima e aérea. Costituisci una società offshore con i nostri servizi legali specializzati.",
        cta: "Richiedi una consulenza personalizzata",
      },
      foundation: {
        title: "Fondazioni di Interesse Privato",
        description: "Proteggi il tuo patrimonio con una fondazione di interesse privato. Strutture legali ottimizzate per la protezione patrimoniale.",
        cta: "Contattaci per maggiori informazioni",
      },
      banking: {
        title: "Apertura Conti Bancari",
        description: "Apri un conto bancario a Panama con il nostro supporto legale. Processo semplice e sicuro con piena riservatezza bancaria.",
        cta: "Scopri di più",
      },
      corporation: {
        title: "Società Anonime",
        description: "Costituisci una società anonima a Panama con il nostro supporto legale. Benefici fiscali e privacy garantita in un paese con tassazione territoriale.",
        cta: "Richiedi una consulenza",
      },
      realestate: {
        title: "Servizi Immobiliari",
        description: "Investi nel mercato immobiliare di Panama con la nostra assistenza legale. Massima sicurezza e trasparenza nelle transazioni.",
        cta: "Contattaci per saperne di più",
      },
      taxresidence: {
        title: "Residenza Fiscale",
        description: "Ottieni la residenza fiscale a Panama e approfitta dei benefici della tassazione territoriale. Ideale per operatori finanziari e imprenditori digitali.",
        cta: "Scopri come possiamo aiutarti",
      },
      immigration: {
        title: "Il tuo percorso di immigrazione",
        description: "La nostra esperienza e professionalità in ambito immigrazione ci consente di offrire un servizio di eccellenza agli stranieri per tutte le procedure di residenza.",
        cta: "Scopri il nostro supporto",
      },
      investment: {
        title: "Servizi di Investimento",
        description: "Consulenza specializzata per investimenti a Panama. Opportunità immobiliari, finanziarie e commerciali con massima sicurezza e rendimento.",
        cta: "Scopri le opportunità",
      },
      accounting: {
        title: "Servizi Contabili",
        description: "Gestione contabile completa per società e privati. Compliance fiscale, reporting e consulenza contabile specializzata per Panama.",
        cta: "Richiedi consulenza contabile",
      },
      legal: {
        title: "Servizi Legali Specializzati",
        description: "I nostri avvocati sono qui per consigliarti nei casi di: Processo esecutivo, Rapimento, Successione testamentaria, Successione legittima, Domanda ordinaria, Embargo",
        cta: "Richiedi assistenza legale",
      },
    },
    partners: {
      title: "I Nostri Partner",
      atlas: {
        title: "Atlas Vaults - Sicurezza di Livello 6 nel Cuore di Panama",
        description: "Atlas Vaults è il nostro partner di fiducia per la custodia sicura dei vostri beni preziosi. Offrono servizi di deposito offshore con la massima sicurezza e privacy nel cuore di Panama.",
        features: [
          "Caveau di massima sicurezza con tecnologia all'avanguardia",
          "Servizio esclusivo per clientela internazionale",
          "Specializzati nella custodia di oro e argento",
          "Alternativa sicura ai sistemi bancari tradizionali",
          "Privacy e discrezione assoluta",
          "Stabilità del sistema finanziario panamense"
        ],
        cta: "Scopri i Servizi di Atlas Vaults"
      }
    },
    contact: {
      title: "Contattaci",
      subtitle: "Siamo qui per aiutarti con le tue esigenze legali e fiscali a Panama",
      office: "Ufficio",
      phone: "Telefono",
      email: "Email",
      website: "Sito Web",
      info: {
        title: "I Nostri Contatti",
        getInTouch: "Parliamo del tuo progetto",
        description: "Clicca il pulsante qui sotto per inviarci una email. Ti risponderemo il prima possibile per discutere delle tue esigenze.",
        emailUs: "Inviaci una email"
      },
      form: {
        title: "Modulo di Contatto",
        name: "Nome",
        email: "Email",
        phone: "Telefono",
        subject: "Oggetto",
        message: "Messaggio",
        submit: "Invia Messaggio",
        success: "Messaggio inviato con successo!"
      }
    },
    footer: {
      description: "RS International Services è il tuo partner di fiducia per servizi legali e fiscali a Panama. Offriamo soluzioni personalizzate per residenza, società offshore e investimenti.",
      quickLinks: "Link Rapidi",
      privacy: "Privacy Policy",
      terms: "Termini e Condizioni",
      copyright: "© 2025 RS International Services. All rights reserved.",
      rights: "Tutti i diritti riservati."
    },
    office: {
      title: "Il Nostro Ufficio",
      staff: "Il Nostro Staff"
    },
    blog: {
      title: "Blog",
      subtitle: "Articoli e approfondimenti sui servizi legali e fiscali a Panama",
      readMore: "Leggi di più",
      publishedOn: "Pubblicato il",
      noArticles: "Nessun articolo disponibile al momento.",
      backToBlog: "Torna al Blog"
    },
    podcast: {
      title: "Podcast",
      subtitle: "Ascolta i nostri contenuti esclusivi su Panama",
      play: "Riproduci",
      pause: "Pausa",
      episode: "Episodio",
      duration: "Durata",
      publishedOn: "Pubblicato il",
      category: "Categoria",
      noEpisodes: "Nessun episodio disponibile al momento.",
      loading: "Caricamento...",
      currentTime: "Tempo corrente",
      totalTime: "Durata totale",
      volume: "Volume",
      mute: "Silenzia",
      unmute: "Riattiva audio"
    },
    leadMagnet: {
      title: "Guida Gratuita: Residenza a Panama per Italiani",
      subtitle: "Scopri tutti i segreti per ottenere la residenza permanente alle condizioni piu' competitive del mercato",
      socialProof: "⭐ Oltre 2.000 italiani hanno già scaricato questa guida",
      whatYouWillFind: "Cosa Troverai nella Guida:",
      benefitsTitle: "Cosa Troverai nella Guida",
      benefits: [
        "Il Trattato di Amicizia Italia-Panama spiegato in dettaglio",
        "Checklist completa dei documenti necessari",
        "Timeline dettagliata del processo (3-6 mesi)",
        "Costi reali e budget da pianificare",
        "Vantaggi fiscali e opportunità di business",
        "Errori comuni da evitare assolutamente"
      ],
      exclusiveBonus: "💡 Bonus Esclusivo: Template email per comunicare con le autorità panamensi",
      form: {
        title: "Scarica la Guida Gratuita",
        subtitle: "Inserisci i tuoi dati per ricevere immediatamente la guida completa via email",
        description: "Inserisci i tuoi dati per ricevere immediatamente la guida completa via email",
        nameLabel: "Nome e Cognome *",
        namePlaceholder: "Mario Rossi",
        emailLabel: "Email *",
        emailPlaceholder: "mario.rossi@email.com",
        phoneLabel: "Telefono (opzionale)",
        phonePlaceholder: "+39 123 456 7890",
        interestLabel: "Principale interesse *",
        interestPlaceholder: "Seleziona il tuo interesse",
        interestOptions: [
          { value: "residenza", label: "Residenza Permanente" },
          { value: "business", label: "Aprire un Business" },
          { value: "investimenti", label: "Investimenti Immobiliari" },
          { value: "fiscale", label: "Ottimizzazione Fiscale" },
          { value: "pensione", label: "Pensione a Panama" }
        ],
        submitButton: "Scarica la Guida Gratuita",
        privacyText: "🔒 I tuoi dati sono protetti. Non condividiamo mai le tue informazioni.",
        features: {
          immediate: "Download immediato",
          free: "100% Gratuito",
          noSpam: "No spam"
        },
        loadingText: "⏳ Invio in corso...",
        sending: "Invio in corso...",
        successMessage: "✅ Richiesta ricevuta! Ti invieremo la guida entro 24 ore.",
        errorMessage: "❌ Errore nell'invio. Riprova più tardi.",
        connectionError: "❌ Errore di connessione. Riprova più tardi."
      }
    }
  },
  es: {
    nav: {
      title: "Menú",
      home: "Inicio",
      about: "Quiénes Somos",
      services: "Servicios",
      podcast: "Podcast",
      blog: "Blog",
      contact: "Contacto",
    },
    hero: {
      title: "Soluciones legales y fiscales a medida en Panamá",
      subtitle: "Confía en un experto para tu residencia, sociedades offshore e inversiones",
      cta: "Solicita una consultoría personalizada",
    },
    about: {
      title: "Quiénes Somos",
      description: "Somos un equipo de abogados y consultores financieros, especializados en diferentes áreas del derecho y trabajamos con determinación para garantizar la satisfacción de nuestros clientes.",
      payment: "Nuestra política establece el pago solo al finalizar el procedimiento, garantizando así la máxima transparencia y seguridad para nuestros clientes.",
      cta: "Solicita una consultoría gratuita",
      experience: "Años de Experiencia",
      clients: "Clientes Satisfechos",
    },
    services: {
      title: "Nuestros Servicios",
      subtitle: "Soluciones legales y fiscales completas para tu vida y tus negocios en Panamá",
      residence: {
        title: "Residencia en Panamá",
        description: "Obtén la residencia en Panamá con el apoyo de un experto. Residencia permanente inmediata a través del Tratado Panamá-Italia. Pasaporte panameño en 5 años. Ideal para nómadas digitales y fiscales.",
        cta: "Contáctanos para saber más",
      },
      offshore: {
        title: "Sociedades Offshore",
        description: "Panamá es líder en servicios offshore, logística marítima y aérea. Constituye una sociedad offshore con nuestros servicios legales especializados.",
        cta: "Solicita una consultoría personalizada",
      },
      foundation: {
        title: "Fundaciones de Interés Privado",
        description: "Protege tu patrimonio con una fundación de interés privado. Estructuras legales optimizadas para la protección patrimonial.",
        cta: "Contáctanos para más información",
      },
      banking: {
        title: "Apertura de Cuentas Bancarias",
        description: "Abre una cuenta bancaria en Panamá con nuestro apoyo legal. Proceso simple y seguro con plena confidencialidad bancaria.",
        cta: "Descubre más",
      },
      corporation: {
        title: "Sociedades Anónimas",
        description: "Constituye una sociedad anónima en Panamá con nuestro apoyo legal. Beneficios fiscales y privacidad garantizada en un país con tributación territorial.",
        cta: "Solicita una consultoría",
      },
      realestate: {
        title: "Servicios Inmobiliarios",
        description: "Invierte en el mercado inmobiliario de Panamá con nuestra asistencia legal. Máxima seguridad y transparencia en las transacciones.",
        cta: "Contáctanos para saber más",
      },
      taxresidence: {
        title: "Residencia Fiscal",
        description: "Obtén la residencia fiscal en Panamá y aprovecha los beneficios de la tributación territorial. Ideal para operadores financieros y emprendedores digitales.",
        cta: "Descubre cómo podemos ayudarte",
      },
      immigration: {
        title: "Tu camino migratorio",
        description: "Nuestra experiencia y profesionalidad en el ámbito de la inmigración nos permite ofrecer un servicio de excelencia a los extranjeros en todos los procedimientos de residencia.",
        cta: "Descubre nuestro apoyo",
      },
      investment: {
        title: "Servicios de Inversión",
        description: "Consultoría especializada para inversiones en Panamá. Oportunidades inmobiliarias, financieras y comerciales con máxima seguridad y rendimiento.",
        cta: "Descubre las oportunidades",
      },
      accounting: {
        title: "Servicios Contables",
        description: "Gestión contable completa para sociedades y particulares. Cumplimiento fiscal, reporting y consultoría contable especializada para Panamá.",
        cta: "Solicita consultoría contable",
      },
      legal: {
        title: "Servicios Legales Especializados",
        description: "Nuestros abogados están aquí para asesorarte en casos de: Proceso ejecutivo, Secuestro, Sucesión testamentaria, Sucesión legítima, Demanda ordinaria, Embargo",
        cta: "Solicita asistencia legal",
      },
    },
    partners: {
      title: "Nuestros Socios",
      atlas: {
        title: "Atlas Vaults - Seguridad de Nivel 6 en el Corazón de Panamá",
        description: "Atlas Vaults es nuestro socio de confianza para la custodia segura de sus bienes valiosos. Ofrecen servicios de depósito offshore con la máxima seguridad y privacidad en el corazón de Panamá.",
        features: [
          "Bóveda de máxima seguridad con tecnología de vanguardia",
          "Servicio exclusivo para clientela internacional",
          "Especializados en la custodia de oro y plata",
          "Alternativa segura a los sistemas bancarios tradicionales",
          "Privacidad y discreción absoluta",
          "Estabilidad del sistema financiero panameño"
        ],
        cta: "Descubre los Servicios de Atlas Vaults"
      }
    },
    contact: {
      title: "Contacto",
      subtitle: "Estamos aquí para ayudarte con tus necesidades legales y fiscales en Panamá",
      office: "Oficina",
      phone: "Teléfono",
      email: "Email",
      website: "Sitio Web",
      info: {
        title: "Nuestros Contactos",
        getInTouch: "Hablemos de tu proyecto",
        description: "Haz clic en el botón de abajo para enviarnos un correo electrónico. Te responderemos lo antes posible para discutir tus necesidades.",
        emailUs: "Envíanos un email"
      },
      form: {
        title: "Formulario de Contacto",
        name: "Nombre",
        email: "Email",
        phone: "Teléfono",
        subject: "Asunto",
        message: "Mensaje",
        submit: "Enviar Mensaje",
        success: "¡Mensaje enviado con éxito!"
      }
    },
    footer: {
      description: "RS International Services es tu socio de confianza para servicios legales y fiscales en Panamá. Ofrecemos soluciones personalizadas para residencia, sociedades offshore e inversiones.",
      quickLinks: "Enlaces Rápidos",
      privacy: "Política de Privacidad",
      terms: "Términos y Condiciones",
      copyright: "© 2025 RS International Services. Todos los derechos reservados.",
      rights: "Todos los derechos reservados."
    },
    office: {
      title: "Nuestra Oficina",
      staff: "Nuestro Personal"
    },
    blog: {
      title: "Blog",
      subtitle: "Artículos y análisis sobre servicios legales y fiscales en Panamá",
      readMore: "Leer más",
      publishedOn: "Publicado el",
      noArticles: "No hay artículos disponibles en este momento.",
      backToBlog: "Volver al Blog"
    },
    podcast: {
      title: "Podcast",
      subtitle: "Escucha nuestros contenidos exclusivos sobre Panamá",
      play: "Reproducir",
      pause: "Pausa",
      episode: "Episodio",
      duration: "Duración",
      publishedOn: "Publicado el",
      category: "Categoría",
      noEpisodes: "No hay episodios disponibles en este momento.",
      loading: "Cargando...",
      currentTime: "Tiempo actual",
      totalTime: "Duración total",
      volume: "Volumen",
      mute: "Silenciar",
      unmute: "Reactivar audio"
    },
    leadMagnet: {
      title: "Guía Gratuita: Residencia en Panamá para Italianos",
      subtitle: "Descubre todos los secretos para obtener la residencia permanente con solo 5.000 USD",
      socialProof: "⭐ Más de 2.000 italianos ya han descargado esta guía",
      whatYouWillFind: "Qué Encontrarás en la Guía:",
      benefitsTitle: "Qué Encontrarás en la Guía",
      benefits: [
        "El Tratado de Amistad Italia-Panamá explicado en detalle",
        "Lista completa de documentos requeridos",
        "Cronograma detallado del proceso (3-6 meses)",
        "Costos reales y presupuesto a planificar",
        "Ventajas fiscales y oportunidades de negocio",
        "Errores comunes que se deben evitar absolutamente"
      ],
      exclusiveBonus: "💡 Bono Exclusivo: Plantilla de email para comunicarse con las autoridades panameñas",
      form: {
        title: "Descarga la Guía Gratuita",
        subtitle: "Ingresa tus datos para recibir inmediatamente la guía completa por email",
        description: "Ingresa tus datos para recibir inmediatamente la guía completa por email",
        nameLabel: "Nombre y Apellido *",
        namePlaceholder: "Mario Rossi",
        emailLabel: "Email *",
        emailPlaceholder: "mario.rossi@email.com",
        phoneLabel: "Teléfono (opcional)",
        phonePlaceholder: "+39 123 456 7890",
        interestLabel: "Principal interés *",
        interestPlaceholder: "Selecciona tu interés",
        interestOptions: [
          { value: "residenza", label: "Residencia Permanente" },
          { value: "business", label: "Abrir un Negocio" },
          { value: "investimenti", label: "Inversiones Inmobiliarias" },
          { value: "fiscale", label: "Optimización Fiscal" },
          { value: "pensione", label: "Jubilación en Panamá" }
        ],
        submitButton: "Descargar la Guía Gratuita",
        privacyText: "🔒 Tus datos están protegidos. Nunca compartimos tu información.",
        features: {
          immediate: "Descarga inmediata",
          free: "100% Gratuito",
          noSpam: "Sin spam"
        },
        loadingText: "⏳ Enviando...",
        sending: "Enviando...",
        successMessage: "✅ ¡Solicitud recibida! Te enviaremos la guía en 24 horas.",
        errorMessage: "❌ Error en el envío. Inténtalo más tarde.",
        connectionError: "❌ Error de conexión. Inténtalo más tarde."
      }
    }
  },
  en: {
    nav: {
      title: "Menu",
      home: "Home",
      about: "About Us",
      services: "Services",
      podcast: "Podcast",
      blog: "Blog",
      contact: "Contact",
    },
    hero: {
      title: "Tailored Legal and Tax Solutions in Panama",
      subtitle: "Trust an expert for your residence, offshore companies, and investments",
      cta: "Request a Personalized Consultation",
    },
    about: {
      title: "About Us",
      description: "We are a team of lawyers and financial consultants, specialized in different areas of law and working with determination to ensure our clients' satisfaction.",
      payment: "Our policy establishes payment only upon completion of the procedure, thus guaranteeing maximum transparency and security for our clients.",
      cta: "Request a Free Consultation",
      experience: "Years of Experience",
      clients: "Satisfied Clients",
    },
    services: {
      title: "Our Services",
      subtitle: "Complete legal and tax solutions for your life and business in Panama",
      residence: {
        title: "Panama Residence",
        description: "Obtain Panama residence with expert support. Immediate permanent residence through the Panama-Italy Treaty. Panama passport in 5 years. Ideal for digital and tax nomads.",
        cta: "Contact us to learn more",
      },
      offshore: {
        title: "Offshore Companies",
        description: "Panama is a leader in offshore services, maritime and air logistics. Establish an offshore company with our specialized legal services.",
        cta: "Request a personalized consultation",
      },
      foundation: {
        title: "Private Interest Foundations",
        description: "Protect your assets with a private interest foundation. Optimized legal structures for asset protection.",
        cta: "Contact us for more information",
      },
      banking: {
        title: "Bank Account Opening",
        description: "Open a bank account in Panama with our legal support. Simple and secure process with full banking confidentiality.",
        cta: "Learn more",
      },
      corporation: {
        title: "Anonymous Corporations",
        description: "Establish an anonymous corporation in Panama with our legal support. Tax benefits and guaranteed privacy in a territorial taxation country.",
        cta: "Request a consultation",
      },
      realestate: {
        title: "Real Estate Services",
        description: "Invest in Panama's real estate market with our legal assistance. Maximum security and transparency in transactions.",
        cta: "Contact us to learn more",
      },
      taxresidence: {
        title: "Tax Residency",
        description: "Obtain tax residency in Panama and take advantage of territorial taxation benefits. Ideal for financial operators and digital entrepreneurs.",
        cta: "Discover how we can help you",
      },
      immigration: {
        title: "Your Immigration Journey",
        description: "Our experience and professionalism in immigration allows us to offer excellent service to foreigners for all residence procedures.",
        cta: "Discover our support",
      },
      investment: {
        title: "Investment Services",
        description: "Specialized investment consulting in Panama. Real estate, financial and commercial opportunities with maximum security and returns.",
        cta: "Discover opportunities",
      },
      accounting: {
        title: "Accounting Services",
        description: "Complete accounting management for companies and individuals. Tax compliance, reporting and specialized accounting consulting for Panama.",
        cta: "Request accounting consultation",
      },
      legal: {
        title: "Specialized Legal Services",
        description: "Our lawyers are here to advise you in cases of: Executive process, Kidnapping, Testamentary succession, Legitimate succession, Ordinary claim, Embargo",
        cta: "Request legal assistance",
      },
    },
    partners: {
      title: "Our Partners",
      atlas: {
        title: "Atlas Vaults - Level 6 Security in the Heart of Panama",
        description: "Atlas Vaults is our trusted partner for secure custody of your valuable assets. They offer offshore deposit services with maximum security and privacy in the heart of Panama.",
        features: [
          "Maximum security vault with cutting-edge technology",
          "Exclusive service for international clientele",
          "Specialized in gold and silver custody",
          "Secure alternative to traditional banking systems",
          "Absolute privacy and discretion",
          "Stability of the Panamanian financial system"
        ],
        cta: "Discover Atlas Vaults Services"
      }
    },
    contact: {
      title: "Contact Us",
      subtitle: "We are here to help you with your legal and tax needs in Panama",
      office: "Office",
      phone: "Phone",
      email: "Email",
      website: "Website",
      info: {
        title: "Our Contacts",
        getInTouch: "Let's discuss your project",
        description: "Click the button below to send us an email. We'll get back to you as soon as possible to discuss your needs.",
        emailUs: "Send us an email"
      },
      form: {
        title: "Contact Form",
        name: "Name",
        email: "Email",
        phone: "Phone",
        subject: "Subject",
        message: "Message",
        submit: "Send Message",
        success: "Message sent successfully!"
      }
    },
    footer: {
      description: "RS International Services is your trusted partner for legal and tax services in Panama. We offer personalized solutions for residency, offshore companies and investments.",
      quickLinks: "Quick Links",
      privacy: "Privacy Policy",
      terms: "Terms and Conditions",
      copyright: "© 2025 RS International Services. All rights reserved.",
      rights: "All rights reserved."
    },
    office: {
      title: "Our Office",
      staff: "Our Staff"
    },
    blog: {
      title: "Blog",
      subtitle: "Articles and insights on legal and tax services in Panama",
      readMore: "Read more",
      publishedOn: "Published on",
      noArticles: "No articles available at the moment.",
      backToBlog: "Back to Blog"
    },
    podcast: {
      title: "Podcast",
      subtitle: "Listen to our exclusive content about Panama",
      play: "Play",
      pause: "Pause",
      episode: "Episode",
      duration: "Duration",
      publishedOn: "Published on",
      category: "Category",
      noEpisodes: "No episodes available at the moment.",
      loading: "Loading...",
      currentTime: "Current time",
      totalTime: "Total duration",
      volume: "Volume",
      mute: "Mute",
      unmute: "Unmute"
    },
    leadMagnet: {
      title: "Free Guide: Panama Residency for Italians",
      subtitle: "Discover all the secrets to obtain permanent residency with only 5,000 USD",
      socialProof: "⭐ Over 2,000 Italians have already downloaded this guide",
      whatYouWillFind: "What You'll Find in the Guide:",
      benefitsTitle: "What You'll Find in the Guide",
      benefits: [
        "The Italy-Panama Friendship Treaty explained in detail",
        "Complete checklist of required documents",
        "Detailed timeline of the process (3-6 months)",
        "Real costs and budget to plan",
        "Tax advantages and business opportunities",
        "Common mistakes to absolutely avoid"
      ],
      exclusiveBonus: "💡 Exclusive Bonus: Email template to communicate with Panamanian authorities",
      form: {
        title: "Download the Free Guide",
        subtitle: "Enter your details to immediately receive the complete guide via email",
        description: "Enter your details to immediately receive the complete guide via email",
        nameLabel: "Full Name",
        namePlaceholder: "John Smith",
        emailLabel: "Email",
        emailPlaceholder: "john.smith@email.com",
        phoneLabel: "Phone (optional)",
        phonePlaceholder: "+1 123 456 7890",
        interestLabel: "Main interest",
        interestPlaceholder: "Select your interest",
        interestOptions: [
          { value: "residenza", label: "Permanent Residency" },
          { value: "business", label: "Start a Business" },
          { value: "investimenti", label: "Real Estate Investments" },
          { value: "fiscale", label: "Tax Optimization" },
          { value: "pensione", label: "Retirement in Panama" }
        ],
        submitButton: "Download the Free Guide",
        privacyText: "Your data is protected. We never share your information.",
        features: {
          immediate: "Instant download",
          free: "100% Free",
          noSpam: "No spam"
        },
        loadingText: "Sending...",
        sending: "Sending...",
        successMessage: "✅ Request received! We'll send you the guide within 24 hours.",
        errorMessage: "Sending error. Try again.",
        connectionError: "Connection error. Try again later."
      }
    }
  },
};